import { gridToTickNote, isMetronomeExercise, isSheetExercise, isTrackSetExercise } from '@ezchops/model/lib/lesson';
import { generateTrackSheet } from './generateTrackSheet';
import { MetronomeEvaluator } from './MetronomeEvaluator';
import { SheetEvaluator } from './SheetEvaluator';
export function createExerciseEvaluator(exercise, tempo) {
    if (isSheetExercise(exercise)) {
        return createEvaluator(exercise, tempo);
    }
    else if (isTrackSetExercise(exercise)) {
        return createEvaluator(exercise, tempo);
    }
    else if (isMetronomeExercise(exercise)) {
        return createEvaluator(exercise, tempo);
    }
    else {
        throw new Error('Unknown exercise type');
    }
}
export function createEvaluator(exercise, tempo) {
    if (isSheetExercise(exercise)) {
        const { sheet, grid } = exercise;
        const tickNote = gridToTickNote(grid);
        return createSheetEvaluator(sheet, tempo, tickNote);
    }
    else if (isTrackSetExercise(exercise)) {
        const { periodSegment, track, grid } = exercise;
        const sheet = generateTrackSheet(track, tempo, periodSegment, grid.resolution);
        const tickNote = gridToTickNote(grid);
        return createSheetEvaluator(sheet, tempo, tickNote);
    }
    else if (isMetronomeExercise(exercise)) {
        const { grid, signature } = exercise;
        const tickNote = gridToTickNote(grid);
        return createMetronomeEvaluator(signature, tempo, tickNote);
    }
    else {
        throw new Error('Unknown exercise type');
    }
}
export function createSheetEvaluator(sheet, tempo, tickNote) {
    const practice = { sheet, tempo };
    return new SheetEvaluator(practice, tickNote);
}
export function createMetronomeEvaluator(signature, tempo, tickNote) {
    const practice = {
        signature, tickNote,
        tempo
    };
    return new MetronomeEvaluator(practice);
}
//# sourceMappingURL=createExerciseEvaluator.js.map